import { useContext, useCallback } from "react";

import { useHistory } from "react-router";

import Swal from "sweetalert2";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { validNotNull } from "../../../../utils/validations";
import getBase64 from "../../../../utils/getBase64";
import { notify } from "../../../../utils/notify";
import {
  createProduto,
  findProdutos,
  updateProduto,
  deleteProduto,
  getScaleFile,
  findProductByDescription,
} from "../../../../repositories/qerpapi/erp/estoque/v1/ProdutosRepository";
import { EditorState, convertToRaw } from "draft-js";

import { ProdutoContext } from "../contexts/ProdutoContext";
import InfoImage from "../../../../assets/imgs/campos-localestoque.png";

import MaskService from "../../../../utils/mask/maskService";
import { findEstoques } from "../../../../repositories/qerpapi/erp/estoque/v1/EstoqueRepository";
// import { findCodigoBarraAlternativo } from "../../../../repositories/qerpapi/erp/estoque/v1/CodigoBarrasAlternativos";
import { findUsuarios } from "../../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";
import { findAnpByCode } from "../../../../repositories/qerpapi/outros/CodigoAnpRepository";

export default function useProdutoController() {
  const {
    //Principal
    mainProductId,
    setMainProductId,
    mainPhotos,
    setMainPhotos,
    mainActive,
    setMainActive,
    mainDescription,
    setMainDescription,
    mainManufacturer,
    setMainManufacturer,
    mainBarCode,
    setMainBarCode,
    mainResume,
    setMainResume,
    mainType,
    setMainType,
    mainDepartment,
    setMainDepartment,
    mainSector,
    setMainSector,
    mainGroup,
    setMainGroup,
    mainSubgroup,
    setMainSubgroup,
    mainIcmsEcf,
    setMainIcmsEcf,
    mainNcm,
    setMainNcm,
    mainCest,
    setMainCest,
    mainGtin,
    setMainGtin,
    mainTaxGtin,
    setMainTaxGtin,
    mainStockUnit,
    setMainStockUnit,
    mainSalesUnit,
    setMainSalesUnit,
    mainTaxUnit,
    setMainTaxUnit,
    mainDeliveryUnit,
    setMainDeliveryUnit,
    mainCodeAnp,
    setMainCodeAnp,
    mainGrossCost,
    setMainGrossCost,
    mainRealCost,
    setMainRealCost,
    mainSalesMargin,
    setMainSalesMargin,
    mainSalePrice,
    setMainSalePrice,
    mainTaxPrice,
    setMainTaxPrice,
    mainConversionFactor,
    setMainConversionFactor,
    taxConversionFactor,
    setTaxConversionFactor,
    productBackup,
    setProductBackup,
    mainUseBalance,

    //Custos e Preços
    mainFreightValue,
    setMainFreightValue,
    mainFreightPercentage,
    setMainFreightPercentage,
    mainInsuranceValue,
    setMainInsuranceValue,
    mainInsurancePercentage,
    setMainInsurancePercentage,
    mainDiscountValue,
    setMainDiscountValue,
    mainDiscountPercentage,
    setMainDiscountPercentage,
    mainOthersValue,
    setMainOthersValue,
    mainOthersPercentage,
    setMainOthersPercentage,
    mainIcmsStValue,
    setMainIcmsStValue,
    mainIcmsStPercentage,
    setMainIcmsStPercentage,
    mainIpiValue,
    setMainIpiValue,
    mainIpiPercentage,
    setMainIpiPercentage,
    mainPisValue,
    setMainPisValue,
    mainPisPercentage,
    setMainPisPercentage,
    mainCofinsValue,
    setMainCofinsValue,
    mainCofinsPercentage,
    setMainCofinsPercentage,
    mainWholesaleValue,
    setMainWholesaleValue,
    setMainUseBalance,
    fixedPrice,
    setFixedPrice,

    //Códigos de Barras Adicionais
    barCodeAdditional,
    setBarCodeAdditional,
    setBarCodeAdditionalModal,

    //Locais de estoque
    stockLocations,
    setStockLocations,

    //tabela de preco
    priceTable,
    setPriceTable,

    //Fornecedores
    supplier,
    setSupplier,
    setSupplierRef,
    supplierPurchaseUnit,
    setSupplierPurchaseUnit,
    supplierDescription,
    setSupplierDescription,
    supplierRef,
    supplierOthers,
    setSupplierOthers,
    supplierConversionFactor,
    setSupplierConversionFactor,

    //Ficha Técnica/Comercial/Combustivel
    datasheetWeight,
    setDatasheetWeight,
    datasheetCubage,
    setDatasheetCubage,
    datasheetQtdPackaging,
    setDatasheetQtdPackaging,
    datasheetWidth,
    setDatasheetWidth,
    datasheetHeight,
    setDatasheetHeight,
    datasheetLength,
    setDatasheetLength,
    datasheetAnvisa,
    setDatasheetAnvisa,
    datasheetGeneric,
    setDatasheetGeneric,
    datasheetObservation,
    setDatasheetObservation,
    datasheetBlockNf,
    setDatasheetBlockNf,
    datasheetBlockCf,
    setDatasheetBlockCf,
    setDatasheetPublishedPrice,
    setDatasheetTrackPrice,
    datasheetCommercialPartner,
    setDatasheetLastSale,
    datasheetLastPurchase,
    setDatasheetLastPurchase,
    setDatasheetLastBudget,
    setDataSheetTags,
    setDataEditor,
    dataSheetTags,
    datasheetDepth,
    setDatasheetDepth,
    datasheetDescriptionANP,
    setDatasheetDescriptionANP,
    datasheetGlpPetroleum,
    setDatasheetGlpPetroleum,
    datasheetNationalGas,
    setDatasheetNationalGas,
    datasheetImportedGas,
    setDatasheetImportedGas,
    datasheetStartingValueWithoutICMS,
    setDatasheetStartingValueWithoutICMS,

    //Relacionados, Similares e Transformação
    relatedProducts,
    setRelatedProducts,
    similarProducts,
    setSimilarProducts,
    transformationProducts,
    setTransformationProducts,

    //Integração
    woocomerceShowSite,
    setWoocomerceShowSite,
    woocomerceUpdateSite,
    setWoocomerceUpdateSite,
    lunetNegativeStock,
    setLunetNegativeStock,
    dataEditor,

    setExpanded,
    setLoading,
    setErrors,
    listSupplier,
  } = useContext(ProdutoContext);
  const { queryParams } = useContext(QueryParamsContext);
  const { push, go } = useHistory();

  const handleCreateBarCode = async (setBarCode) => {
    try {
      setLoading(true);

      if (!queryParams.empresa_id) return;

      const companyParams = {
        getParamutilizacor: queryParams.paramutilizacor,
        getParamutilizatamanho: queryParams.paramutilizatamanho,
        getCodigobarraslocalestoque: queryParams.codigobarraslocalestoque,
        getParambuscacodigobarras: queryParams.parambuscacodigobarras,
        getTipocodigobarras: queryParams.tipocodigobarras,
      };

      const ean13 = "EAN13";
      let msgError = "";
      let barCode = null;
      let maxLenght = 20; //$this->getRequest()->getParam("maxlength");
      let min = 1;
      let max = 99999;

      if (maxLenght === 4) max = 9999;

      if (companyParams.getTipocodigobarras === ean13) {
        min = 100000;
        max = 999999;
      }

      let attempts = 0;
      while (attempts < 30) {
        attempts++;

        if (companyParams.getTipocodigobarras === ean13) {
          barCode = Math.floor(Math.random() * max) + min;
          barCode = `${barCode}${Math.floor(Math.random() * 999999) + 100000}`;

          const digits = barCode.split("");
          let sum = 0;
          digits.forEach((digit, index) => {
            sum += index % 2 === 0 ? Number(digit) : Number(digit * 3);
          });

          const result = (Math.floor(sum / 10) + 1) * 10 - sum;
          barCode = (result % 10 === 0 ? "0" : result) + barCode;

          if (barCode.length !== 13) {
            barCode = null;
            continue;
          }
        } else {
          barCode = (Math.floor(Math.random() * max) + min).toString();
        }

        if (
          companyParams.getParamutilizacor === "SIM" ||
          companyParams.getParamutilizatamanho === "SIM" ||
          companyParams.getCodigobarraslocalestoque === "SIM"
        ) {
          let countStock = await findEstoques({
            empresa_cnpj: queryParams.empresa_cnpj,
            where: { codigobarras: barCode },
            fields: "[estoque.estoque]=codigobarras",
          }); //findEstoque() where("e.codigobarras = barCode")

          if (countStock?.data.length === 0) {
            break;
          }
        } else {
          if (companyParams.getParambuscacodigobarras === "SIM") {
            if (companyParams.getCodigobarraslocalestoque === "SIM") {
              let countStock = await findEstoques({
                empresa_cnpj: queryParams.empresa_cnpj,
                where: { codigobarras: barCode },
                fields: "[estoque.estoque]=codigobarras",
              }); //findEstoque where("e.codigobarras = '$barCode'")

              if (countStock?.data.length === 0) {
                break;
              }
            } else {
              let countProduct = await findProdutos({
                empresa_cnpj: queryParams.empresa_cnpj,
                where: { codigobarras: barCode },
              }); //findProduto where("p.codigobarras = '$barCode'")

              if (countProduct?.data.length === 0) {
                break;
              }
            }
          } else {
            msgError =
              "Impossível criar código de barras. O sistema atual não utiliza codigo de barras.";
            break;
          }
        }

        barCode = null;
      }

      if (barCode === null) {
        return notify(
          "O sistema não conseguiu gerar um código de barras válido dentro de trinta tentativas. Tente novamente."
        );
      } else if (msgError) {
        return notify(msgError);
      }

      setBarCode(barCode || "");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  /**
   *
   * @param {array | string} barCodes - Pode ser um array ou uma string,
   * são os códigos á validar.
   *
   * @returns - Um objeto contendo o status do erro, e, caso contenha
   * algum código já existente, retorna um índice "founds" que é um
   * array contendo os códigos duplicados encontrados
   */
  const validateBarCode = async (barCodes = [] || "") => {
    let founds = [];
    let query;
    let codesArray = [];

    if (Array.isArray(barCodes) && barCodes.length) {
      let codeQuery = [];

      barCodes.forEach((code) => {
        codeQuery.push({
          codigobarras: code,
        });

        codesArray.push(code);
      });

      query = {
        empresa_cnpj: queryParams.empresa_cnpj,
        orwhere: codeQuery,
        isSameOrWhere: true,
      };
    } else if (typeof barCodes === "string") {
      codesArray.push(barCodes);

      query = {
        empresa_cnpj: queryParams.empresa_cnpj,
        where: { codigobarras: barCodes },
      };
    } else return;

    let barCodeError = await findEstoques(query);

    if (barCodeError.data.length) {
      barCodeError.data.forEach(({ codigobarras }) => {
        if (
          typeof codigobarras === "string" &&
          codesArray.includes(codigobarras.replaceAll(" ", ""))
        )
          founds.push(codigobarras.replaceAll(" ", ""));
      });
    }

    if (!founds) {
      barCodeError = await findProdutos(query);

      if (!!barCodeError.data.length) {
        barCodeError.data.forEach(({ codigobarras }) => {
          if (
            typeof codigobarras === "string" &&
            codesArray.includes(codigobarras.replaceAll(" ", ""))
          )
            founds.push(codigobarras.replaceAll(" ", ""));
        });
      }

      // verificacao na tabela codigodebarrasalternativos
      // if (!founds) {
      //   barCodeError = await findCodigoBarraAlternativo(query);

      //   if (!!barCodeError.data.length) {
      //     barCodeError.data.forEach(({ codigobarras }) => {
      //   if (
      //     typeof codigobarras === "string" &&
      //     codesArray.includes(codigobarras.replaceAll(" ", ""))
      //   )
      //     founds.push(codigobarras.replaceAll(" ", ""));
      // });
      //   }
      // }
    }

    if (!!founds.length)
      return {
        error: true,
        founds,
      };
    else
      return {
        error: false,
      };
  };

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const removeMaskDecimal = useCallback((value = "", fixed = 2) => {
    if (typeof value === "number") return parseFloat(value.toFixed(fixed));
    if (typeof value !== "string") return 0;
    return parseFloat(
      parseFloat(value.replace(/\./g, "").replace(",", ".")).toFixed(fixed)
    );
  }, []);

  const changeUStoBR = (value = "") => {
    if (value.length > 0) {
      value = value.replace(",", "");

      return parseFloat(value.replace(".", ",")).toFixed(2);
    }
    return value;
  };

  const handleSubmit = async (again) => {
    try {
      setLoading(true);

      //Main Verification
      const validationMain = validNotNull([
        { key: "mainDescription", value: mainDescription },
        { key: "mainGroup", value: mainGroup },
        { key: "mainSubgroup", value: mainSubgroup },
        { key: "mainStockUnit", value: mainStockUnit },
      ]);

      const validationStockLocations = validNotNull([
        { key: "stockLocations", value: stockLocations[0] },
      ]);

      setErrors({
        ...validationMain.errorsValidation,
        ...validationStockLocations.errorsValidation,
        accordionMain: validationMain.error,
        accordionStockLocationsLength: validationStockLocations.error,
      });

      if (validationMain.error || validationStockLocations.error)
        return notify("Verifique se todos os campos foram preenchidos.");

      const checkDescription = await findProductByDescription({
        empresa_cnpj: queryParams.empresa_cnpj,
        description: mainDescription,
      });

      if (
        checkDescription.data.length &&
        !checkDescription.data.find((current) => current.id === mainProductId)
      ) {
        setLoading(false);
        return notify("Descrição já usada em outro produto");
      }

      //if verifications
      if (
        queryParams.parambuscacodigobarras === "SIM" &&
        queryParams.codigobarraslocalestoque === "NAO"
      ) {
        const validationBar = validNotNull([
          { key: "mainBarCode", value: mainBarCode },
        ]);

        setErrors({
          ...validationBar.errorsValidation,
          accordionBar: validationBar.error,
        });

        if (validationBar.error)
          return notify(
            "Verifique se os campos estão preenchidos corretamente."
          );
      }
      if (queryParams.codigobarraslocalestoque === "NAO") {
        let validBarCode;

        if (
          !mainProductId ||
          (mainProductId &&
            (productBackup?.codigobarras || "").replaceAll(" ", "") !==
              (mainBarCode || "").replaceAll(" ", ""))
        )
          validBarCode = await validateBarCode(mainBarCode);

        if (validBarCode?.error) {
          setErrors((old) => ({
            ...old,
            error: true,
            mainBarCode: "Código já encontrado no sistema.",
          }));

          return notify(
            "Código de barras já está em uso. Tente novamente com outro código"
          );
        }
      }

      if (queryParams.utilizadepartamentosetor === "SIM") {
        const validationDepartment = validNotNull([
          { key: "mainDepartment", value: mainDepartment },
          { key: "mainSector", value: mainSector },
        ]);

        setErrors({
          ...validationDepartment.errorsValidation,
          accordionBar: validationDepartment.error,
        });

        if (validationDepartment.error)
          return notify(
            "Verifique se os campos estão preenchidos corretamente."
          );
      }

      /* Cálculo sobre os valores ANP (Combustível) */
      if (mainCodeAnp) {
        const soma =
          parseFloat(datasheetGlpPetroleum.replace(",", ".")) +
          parseFloat(datasheetNationalGas.replace(",", ".")) +
          parseFloat(datasheetImportedGas.replace(",", "."));

        if (soma !== 100) {
          notify(
            `Soma do Rateio Combustível ${
              soma > 100 ? "maior" : "menor"
            } que 100%.`,
            true,
            "warning"
          );
        }
      }

      const arrFiles = [];
      if (mainPhotos.filter((photo) => photo.checkMain).length > 1)
        return notify(
          "Selecione somente uma imagem como principal para salvar"
        );
      for (const photo of mainPhotos) {
        let obj = {};
        /* Nova Foto */
        if (photo.uploaded) {
          const fileBase64 = await getBase64(photo.file);
          const base64 = fileBase64.split(";base64,");

          if (!base64[1]) return notify("Arquivo de Imagem Invalido.");

          obj = {
            arquivo: photo.name,
            principal: photo.checkMain ? "S" : "N",
            imagebase64: base64[1],
          };
        } else {
          /* Foto Existente */
          obj = {
            id: photo.id,
            arquivo: photo.name,
            s3_key: photo.s3_key,
            principal: photo.checkMain ? "S" : "N",
            imagebase64: photo.file,
          };

          if (!obj.s3_key) delete obj.s3_key;
        }

        arrFiles.push(obj);
      }

      let stocks = [...stockLocations];
      let codes = [];
      let validation;

      if (queryParams.codigobarraslocalestoque === "SIM") {
        if (!mainProductId) {
          stocks.forEach((stock) => {
            if (stock.codigobarras) {
              const { codigobarras } = stock;

              codes.push(codigobarras);
            }

            if (
              queryParams.permitecodigobarrasadicionais === "SIM" &&
              stock.codigosbarrasalternativos
            ) {
              const { codigosbarrasalternativos } = stock;

              codigosbarrasalternativos.forEach((code) =>
                codes.push(code.codigobarras)
              );
            }
          });
        } else {
          const { estoques } = productBackup;

          stocks.forEach((stock) => {
            let existentStock = estoques.find(
              (e) => e.idlocalestoque === stock.idlocalestoque
            );

            if (
              existentStock &&
              existentStock.codigobarras !== stock.codigobarras
            )
              codes.push(stock.codigobarras);

            if (
              stock.codigosbarrasalternativos &&
              queryParams.permitecodigobarrasadicionais === "SIM"
            ) {
              if (!!existentStock?.codigosbarrasalternativos?.length) {
                let barCodesArray = [];

                existentStock.codigosbarrasalternativos.forEach((barCode) => {
                  barCodesArray.push(barCode.codigobarras.replaceAll(" ", ""));
                });

                stock.codigosbarrasalternativos.forEach((barCode) => {
                  if (!barCodesArray.includes(barCode.codigobarras))
                    codes.push(barCode.codigobarras);
                });
              } else {
                stock.codigosbarrasalternativos.forEach((code) => {
                  codes.push(code.codigobarras.replaceAll(" ", ""));
                });
              }
            }
          });
        }

        validation = await validateBarCode(codes);

        if (validation?.error) {
          stocks = stocks.map((stock) => {
            let error = false;
            let barCodeError = false;

            if (validation.founds.includes(stock.codigobarras))
              barCodeError = true;

            if (
              stock.codigosbarrasalternativos &&
              queryParams.permitecodigobarrasadicionais === "SIM"
            ) {
              stock.codigosbarrasalternativos =
                stock.codigosbarrasalternativos.map((code) => {
                  if (validation.founds.includes(code.codigobarras)) {
                    error = true;

                    return { ...code, rowError: true };
                  }

                  return { ...code };
                });
            }

            if (error || barCodeError) {
              return barCodeError
                ? { ...stock, rowError: true, barCodeError: true }
                : { ...stock, rowError: true, additionalCodeError: true };
            } else return { ...stock };
          });

          setStockLocations(stocks);
          setErrors((old) => ({ ...old, accordionStockLocations: true }));

          return notify("O produto possui códigos de barras já utilizados");
        }
      } else if (
        queryParams.codigobarraslocalestoque === "NAO" &&
        queryParams.permitecodigobarrasadicionais === "SIM"
      ) {
        let additionalBarCodes = [...barCodeAdditional];

        if (!mainProductId) {
          additionalBarCodes.forEach((barCode) =>
            codes.push(barCode.codigobarras)
          );
        } else {
          let existentCodes = productBackup?.codigosbarrasalternativos
            ? [...productBackup?.codigosbarrasalternativos]
            : [];
          let barCodesArray = [];

          existentCodes.forEach((barCode) => {
            barCodesArray.push(barCode.codigobarras.replaceAll(" ", ""));
          });

          additionalBarCodes.forEach((barCode) => {
            if (
              !barCodesArray.includes(barCode.codigobarras.replaceAll(" ", ""))
            )
              codes.push(barCode.codigobarras);
          });
        }

        validation = await validateBarCode(codes);

        if (validation?.error) {
          additionalBarCodes = additionalBarCodes.map((barCode) => {
            if (validation.founds.includes(barCode.codigobarras))
              return { ...barCode, rowError: true };
            else return { ...barCode };
          });

          setBarCodeAdditional(additionalBarCodes);
          setErrors((old) => ({ ...old, additionalBarCode: true }));
          return notify(
            "O produto possui códigos de barras alternativos já utilizados"
          );
        }
      }

      let newAdditionalCodes = barCodeAdditional.map((barCode) => {
        if (barCode.rowError) delete barCode.rowError;

        return { ...barCode };
      });


      let atLeastOneStockLocationActive = false;


      const newStockLocations = stockLocations.map((stock) => {
        if (stock.codigosbarrasalternativos)
          stock.codigosbarrasalternativos = stock.codigosbarrasalternativos.map(
            (code) => {
              if (code.rowError) delete code.rowError;

              return { ...code };
            }
          );

        if (stock.rowError) delete stock.rowError;
        delete stock.descricao;

        if (stock.inativo !== "S" && !atLeastOneStockLocationActive) atLeastOneStockLocationActive = true;
        
        return { ...stock };
      });


      if (mainActive && !atLeastOneStockLocationActive) {
        return notify("Pelo menos um local de estoque deve estar ativo.");
      }

      let similarProductsIds = [];
      similarProducts.forEach((product) => similarProductsIds.push(product.id));

      let relatedProductsIds = [];
      relatedProducts.forEach((product) => relatedProductsIds.push(product.id));

      let newTransformation = [];
      transformationProducts.forEach((product) =>
        newTransformation.push({
          iditemcompoe: product?.id ?? null,
          fator_transformacao: product?.fator
            ? removeMaskDecimal(product.fator, 5)
            : 1,
        })
      );

      let newPriceTable = priceTable.map((table) => {
        table.idtabelapreco = table.id;
        table.comissaopadrao = table.comissaopadrao
          ? removeMaskDecimal(table.comissaopadrao)
          : null;
        table.margem =
          table.margem !== "0.00" ? removeMaskDecimal(table.margem) : null;
        table.descontopadrao = table.descontopadrao
          ? removeMaskDecimal(table.descontopadrao)
          : null;
        table.descontomaximopadrao = table.descontomaximopadrao
          ? removeMaskDecimal(table.descontomaximopadrao)
          : null;

        delete table.customValues;
        delete table.id;
        delete table.descricao;
        delete table.ativo;
        return table;
      });

      let newOtherSuppliers = supplierOthers.map((sup) => {
        delete sup.id;

        return {
          ...sup,
        };
      });

      const userLogin = await findUsuarios(
        queryParams.empresa_cnpj,
        queryParams.usuario_id
      );

      if (!userLogin.success || !userLogin.data) {
        return notify(
          "Ocorreu um erro. Tente novamente com um usuário diferente."
        );
      }

      if (!supplier?.id) {
        setSupplier(
          listSupplier.find((opt) => opt.id === 1) || listSupplier[0] || null
        );
      }
      const body = {
        //Principal
        quemincluiu: userLogin.data.login || "",
        produtosfotos: arrFiles,
        produtoativo: mainActive ? "SIM" : "NÃO",
        descricao: mainDescription,
        idfabricante: mainManufacturer ? mainManufacturer.id : null,
        descricaoresumida: mainResume,
        tipo: mainType ? mainType.id : null,
        idgrupoestoque: mainGroup ? mainGroup.id : null,
        idsubgrupo: mainSubgroup ? mainSubgroup.id : null,
        icms: removeMaskDecimal(MaskService.toMask("decimal", mainIcmsEcf)),
        cest: mainCest ? mainCest.cest : null,
        gtin: mainGtin ? Number(mainGtin) : null,
        unidade: mainStockUnit ? mainStockUnit.un : "",
        unidade_venda: mainSalesUnit
          ? mainSalesUnit.un
          : mainStockUnit?.un ?? "",
        unidade_entrega: mainDeliveryUnit
          ? mainDeliveryUnit.un
          : mainStockUnit?.un ?? "",
        cod_anp: mainCodeAnp,
        ncm: mainNcm ? mainNcm.ncm : null,
        utilizarcodigobalanca: mainUseBalance ? "S" : "N",

        // Local de estoque,
        estoques: newStockLocations,

        //Tabela Preço
        tabelasprecosprodutos: newPriceTable,

        //Fornecedor
        idfornecedor: supplier ? supplier.id : null,
        // supplierRef,

        descricaofornecedor: supplierDescription ?? supplier?.descricao ?? "",
        unidade_compra:
          supplierPurchaseUnit?.un ?? supplier?.unidade_compra ?? "",
        codigoprodutonofornecedor: supplierRef ?? supplier?.codigobarras ?? "",

        //Outros Fornecedores
        fornecedoresprodutos: newOtherSuppliers,

        esptec:
          JSON.stringify(convertToRaw(dataEditor.getCurrentContent())) ?? "",

        //Ficha Técnica/Comercial/Combustivel
        peso: removeMaskDecimal(datasheetWeight, 3),
        cubagem: removeMaskDecimal(datasheetCubage, 3),
        qtdpacote: removeMaskDecimal(datasheetQtdPackaging),
        largura: removeMaskDecimal(datasheetWidth, 3),
        altura: removeMaskDecimal(datasheetHeight, 3),
        comprimento: removeMaskDecimal(datasheetLength, 3),
        profundidade: removeMaskDecimal(datasheetDepth, 3),
        registroanvisa: datasheetAnvisa,
        produtogenerico: datasheetGeneric ? "S" : "N",
        observacao: datasheetObservation,
        travarnf: datasheetBlockNf ? 1 : 0,
        travarcf: datasheetBlockCf ? 1 : 0,
        precoatacado:
          queryParams.paramutilizatabelaprecos === "NAO" &&
          queryParams.paramutilizavarejoatacado === "SIM" &&
          mainWholesaleValue
            ? removeMaskDecimal(mainWholesaleValue)
            : null,
        acompanharpreco: 1, //[QES-2838]: "ao gravar todo novo produto, deixar acompanharpreco habilitado como default"
        idparceirocomercial: datasheetCommercialPartner
          ? datasheetCommercialPartner.id
          : null,
        precoultimacompra: datasheetLastPurchase
          ? removeMaskDecimal(datasheetLastPurchase)
          : null,
        desc_anp: datasheetDescriptionANP,
        perc_glp_derivado_petroleo: removeMaskDecimal(datasheetGlpPetroleum, 4),
        perc_gas_natural_nacional: removeMaskDecimal(datasheetNationalGas, 4),
        perc_gas_natural_importado: removeMaskDecimal(datasheetImportedGas, 4),
        valor_partida_sem_icms: removeMaskDecimal(
          datasheetStartingValueWithoutICMS,
          4
        ),
        fator_conversao_venda:
          mainSalesUnit?.un === mainStockUnit?.un
            ? "1.00000"
            : removeMaskDecimal(mainConversionFactor, 5),
        fator_conversao:
          mainStockUnit?.un === supplierPurchaseUnit?.un
            ? "1.00000"
            : removeMaskDecimal(supplierConversionFactor, 5),
        fator_conversao_tributavel:
          mainSalesUnit?.un === mainTaxUnit?.un
            ? "1.00000"
            : removeMaskDecimal(taxConversionFactor, 5),
        exibe_site: woocomerceShowSite ? "S" : "N",
        produtoatualizado: woocomerceUpdateSite ? "S" : "N",
        integracao_lunet_estoque_negativo: lunetNegativeStock
          ? lunetNegativeStock.id
          : "N",
        produtodevi: "N",
        produtosrelacionados: relatedProductsIds,
        produtossimilares: similarProductsIds,
        produtostransformacoes: newTransformation,
        gtin_tributavel: mainTaxGtin ? Number(mainTaxGtin) : null,
        unidade_tributavel: mainTaxUnit ? mainTaxUnit.un : "",
      };

      // anexo os campos de data, caso existam
      if (mainProductId && productBackup) {
        body["dataultimacompra"] = productBackup.dataultimacompra || null;
        body["dataultimavenda"] = productBackup.dataultimavenda || null;
        body["dataultimoorcamento"] = productBackup.dataultimoorcamento || null;
      }

      if (body.estoques) {
        let newBarCodes = [];

        body.estoques = body.estoques.map((estoque) => {
          if (estoque.codigosbarrasalternativos) {
            estoque.codigosbarrasalternativos.forEach((code) =>
              newBarCodes.push({
                idestoque: estoque.id ?? null,
                codigobarras: code.codigobarras,
              })
            );

            delete estoque.codigosbarrasalternativos;
            return { ...estoque };
          } else {
            if (estoque.codigobarras !== mainBarCode)
              estoque.codigobarras = mainBarCode;
            if (estoque.localestoque) delete estoque.localestoque;
            return { ...estoque };
          }
        });

        if (body.codigosbarrasalternativos) {
          body.codigosbarrasalternativos = [
            ...body.codigosbarrasalternativos,
            ...newBarCodes,
          ];
        } else {
          body.codigosbarrasalternativos = [...newBarCodes];
        }
      }

      if (
        queryParams.paramprecoestoqueunico === "SIM" &&
        queryParams.paramutilizatabelaprecos === "SIM" &&
        queryParams.permiteprecofixo === "SIM"
      ) {
        body.precofixo = fixedPrice ? "SIM" : "NAO";
      }

      //Tags
      let bodyTags = [];
      dataSheetTags.forEach((tag) => {
        bodyTags.push({
          tag: tag,
        });
      });

      body.produtostags = bodyTags;

      if (
        queryParams.permitecodigobarrasadicionais === "SIM" &&
        queryParams.codigobarraslocalestoque === "NAO"
      ) {
        body.codigosbarrasalternativos = newAdditionalCodes;
      }

      if (
        queryParams.parambuscacodigobarras === "SIM" &&
        queryParams.codigobarraslocalestoque === "NAO"
      ) {
        body.codigobarras = mainBarCode;
      } else if (
        queryParams.codigobarraslocalestoque === "NAO" &&
        mainProductId
      ) {
        body.codigobarras = mainProductId.toString() ?? "";
      }
      if (queryParams.utilizadepartamentosetor === "SIM") {
        body.iddepartamento = mainDepartment ? mainDepartment.id : null;

        body.idsetor = mainSector ? mainSector.id : null;
      }
      if (queryParams.paramprecoestoqueunico === "SIM") {
        body.custobruto = removeMaskDecimal(mainGrossCost);
        body.frete = removeMaskDecimal(mainFreightValue);
        body.frete_porc = removeMaskDecimal(mainFreightPercentage);
        body.seguro = removeMaskDecimal(mainInsuranceValue);
        body.seguro_porc = removeMaskDecimal(mainInsurancePercentage);
        body.desconto = removeMaskDecimal(mainDiscountValue);
        body.desconto_porc = removeMaskDecimal(mainDiscountPercentage);
        body.precovenda = removeMaskDecimal(mainSalePrice);
        body.valor_tributavel = removeMaskDecimal(mainTaxPrice);
        body.outrasdesp = removeMaskDecimal(mainOthersValue);
        body.outrasdesp_porc = removeMaskDecimal(mainOthersPercentage);
        body.icmsst = removeMaskDecimal(mainIcmsStValue);
        body.icmsst_porc = removeMaskDecimal(mainIcmsStPercentage);
        body.ipi = removeMaskDecimal(mainIpiValue);
        body.ipi_porc = removeMaskDecimal(mainIpiPercentage);
        body.pis = removeMaskDecimal(mainPisValue);
        body.pis_porc = removeMaskDecimal(mainPisPercentage);
        body.cofins = removeMaskDecimal(mainCofinsValue);
        body.cofins_porc = removeMaskDecimal(mainCofinsPercentage);
        body.porcfixo = removeMaskDecimal(mainSalesMargin);
        body.estoque_custoreal = removeMaskDecimal(mainRealCost);
      }

      let resultSubmit = null;

      if (mainProductId) {
        resultSubmit = await updateProduto(
          mainProductId,
          queryParams.empresa_cnpj,
          {
            produto: body,
          }
        );
      } else {
        resultSubmit = await createProduto(queryParams.empresa_cnpj, {
          produto: body,
        });
      }

      if (resultSubmit && resultSubmit.success) {
        setMainProductId(null);
        clearAll();
        if (again) {
          push(
            "cadastro?empresa_cnpj=" +
              queryParams.empresa_cnpj +
              "&empresa_id=" +
              queryParams.empresa_id +
              "&clearPreviusQueryParams=datanf"
          );
          go(0);
          return notify("Produto salvo com sucesso.", true, "success");
        } else {
          push("/estoque/produto/listagem");
          return notify("Produto salvo com sucesso.", true, "success");
        }
      }

      return notify("Não foi possível salvar os dados do produto.");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelSubmit = () => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja cancelar?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setMainProductId(null);
        clearAll();
        push("/estoque/produto/listagem");
      }
    });
  };

  const handleBackSubmit = () => {
    push("/estoque/produto/listagem");
  };

  const handleRemoveItemTable = (
    setRows,
    setDataTable,
    list,
    index,
    id = null
  ) => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja remover este registro?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const copy = [...list];
        if (id) index = copy.findIndex((e) => e.id === id);
        copy.splice(index, 1);
        setRows(copy);
        setDataTable(copy);
      }
    });
  };

  const handleEditItemTable = (setOpen, setRowEdit, data = {}, index = -1) => {
    setOpen(true);
    setRowEdit({ data, index });
  };

  const handleEditProduct = (setRowEdit, data = {}, index = -1) => {
    setRowEdit({ data, index });
    push(
      "cadastro?empresa_cnpj=" +
        queryParams.empresa_cnpj +
        "&empresa_id=" +
        queryParams.empresa_id,
      { data, index }
    );
  };

  const handleDeleteProduct = (
    id,
    setLoading = () => {},
    setReload = () => {}
  ) => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir o produto?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const callback = await deleteProduct(id);
        if (!callback?.success) {
          setLoading(false);
          return;
        }

        setReload((prev) => !prev);
        setLoading(false);
      }
    });
  };

  const handleCloneProduct = async ({ item }) => {
    item.cloned = true;

    const result = await Swal.fire({
      icon: "question",
      title: "Deseja zerar os valores dos locais de estoque clonados?",
      html: `<details>
              <summary style="color:blue">Visualizar Campos que Serão Zerados</summary>
              <img src="${InfoImage}" style="width: 100%;">
            </details>`,
      showConfirmButton: true,
      confirmButtonText: "Sim, zerar locais de estoque",
      confirmButtonColor: "#dc3545",
      showDenyButton: true,
      denyButtonText: "Não, manter valores",
      denyButtonColor: "#2778c4",
      showCloseButton: true,
    });

    if (result.isConfirmed) item.acceptResetStockLocation = true;
    if (result.isDismissed) return;

    push("cadastro", { item });
  };

  const getRealCost = ({
    custoBrutoEstoque,
    freteEstoque,
    seguroEstoque,
    outrasDespEstoque,
    icmsstEstoque,
    ipiEstoque,
    descontoEstoque,
    cofinsEstoque,
    pisEstoque,
  }) => {
    let realCost =
      parseFloat(custoBrutoEstoque) +
      parseFloat(freteEstoque) +
      parseFloat(seguroEstoque) +
      parseFloat(outrasDespEstoque) +
      parseFloat(icmsstEstoque) +
      parseFloat(ipiEstoque) -
      parseFloat(descontoEstoque);

    if (queryParams.crt === "3") {
      realCost += parseFloat(cofinsEstoque) + parseFloat(pisEstoque);
    }

    return MaskService.toMask("decimal", realCost.toFixed(5), 5);
  };

  const getProductPrice = (value, isBrute = false) => {
    if (isBrute) {
      if (queryParams.paramprecoestoqueunico === "SIM") {
        return parseFloat(value.custobruto_produto)
          ? `R$ ${MaskService.toMask(
              "decimal",
              parseFloat(value.custobruto_produto).toFixed(5),
              5
            )}`
          : "-";
      } else {
        return value.custobruto_estoque
          ? `R$ ${MaskService.toMask(
              "decimal",
              parseFloat(value.custobruto_estoque).toFixed(5),
              5
            )}`
          : "-";
      }
    }
    if (queryParams.paramprecoestoqueunico === "SIM") {
      return value.precovenda_produto
        ? `R$ ${MaskService.toMask(
            "decimal",
            parseFloat(value.precovenda_produto).toFixed(5),
            5
          )}`
        : "-";
    } else {
      return value.precovenda_estoque
        ? `R$ ${MaskService.toMask(
            "decimal",
            parseFloat(value.precovenda_estoque).toFixed(5),
            5
          )}`
        : "-";
    }
  };

  const clearAll = useCallback(() => {
    //Principal
    setProductBackup(null);
    setMainProductId(null);
    setMainPhotos([]);
    setMainActive(true);
    setMainDescription("");
    setMainManufacturer(null);
    setMainBarCode("");
    setMainResume("");
    setMainType({ label: "Revenda", id: "R" });
    setMainDepartment(null);
    setMainSector(null);
    setMainGroup(null);
    setMainSubgroup(null);
    setMainIcmsEcf("");
    setMainNcm(null);
    setMainCest("");
    setMainGtin("");
    setMainTaxGtin("");
    setMainStockUnit(null);
    setMainSalesUnit(null);
    setMainTaxUnit(null);
    setMainDeliveryUnit(null);
    setMainCodeAnp("");

    setMainGrossCost("0,00000");
    setMainRealCost("0,00000");
    setMainSalesMargin("0,00000");
    setMainSalePrice("0,00000");
    setMainTaxPrice("0,00");
    setMainConversionFactor("1,00000");
    setTaxConversionFactor("1,00000");
    setMainWholesaleValue("0,00000");

    setMainUseBalance(false);

    //Custos e Preços
    setMainFreightValue("0,00000");
    setMainFreightPercentage("0,00000");
    setMainInsuranceValue("0,00000");
    setMainInsurancePercentage("0,00000");
    setMainDiscountValue("0,00000");
    setMainDiscountPercentage("0,00000");
    setMainOthersValue("0,00000");
    setMainOthersPercentage("0,00000");
    setMainIcmsStValue("0,00000");
    setMainIcmsStPercentage("0,00000");
    setMainIpiValue("0,00000");
    setMainIpiPercentage("0,00000");
    setMainPisValue("0,0000000");
    setMainPisPercentage("0,00000");
    setMainCofinsValue("0,00000");
    setMainCofinsPercentage("0,00000");
    setFixedPrice(false);

    //Códigos de Barras Adicionais
    setBarCodeAdditional([]);

    //Códigos de Barras Adicionais Modal
    setBarCodeAdditionalModal([]);

    //Locais de estoque
    setStockLocations([]);

    //Tablea Preco
    setPriceTable([]);

    //Fornecedore
    setSupplier(null);
    setSupplierRef("");
    setSupplierPurchaseUnit(null);
    setSupplierDescription(null);
    setSupplierConversionFactor("1,00000");
    setSupplierOthers([]);

    //Ficha Técnica/Comercial/Combustivel
    setDatasheetWeight("0,000");
    setDatasheetCubage("0,000");
    setDatasheetQtdPackaging("0,00");
    setDatasheetWidth("0,000");
    setDatasheetHeight("0,000");
    setDatasheetLength("0,000");
    setDatasheetDepth("0,000");
    setDatasheetAnvisa("");
    setDatasheetGeneric(false);
    setDatasheetObservation("");
    setDatasheetBlockNf(false);
    setDatasheetBlockCf(false);
    setDatasheetPublishedPrice(false);
    setDatasheetTrackPrice(false);
    setDatasheetLastSale("");
    setDatasheetLastPurchase("");
    setDatasheetLastBudget("");
    setDataSheetTags([]);
    setDataEditor(EditorState.createEmpty());
    setDatasheetDescriptionANP("");
    setDatasheetGlpPetroleum("0,0000");
    setDatasheetNationalGas("0,0000");
    setDatasheetImportedGas("0,0000");
    setDatasheetStartingValueWithoutICMS("0,0000");

    //Relacionados, Similares e Transformação
    setRelatedProducts([]);
    setSimilarProducts([]);
    setTransformationProducts([]);

    //Integração
    setWoocomerceShowSite(false);
    setWoocomerceUpdateSite(false);
    setLunetNegativeStock(null);
    setErrors({});
  }, [
    setMainProductId,
    setMainPhotos,
    setMainActive,
    setMainDescription,
    setMainManufacturer,
    setMainBarCode,
    setMainResume,
    setMainType,
    setMainDepartment,
    setMainSector,
    setMainGroup,
    setMainSubgroup,
    setMainIcmsEcf,
    setMainNcm,
    setMainCest,
    setMainGtin,
    setMainTaxGtin,
    setMainStockUnit,
    setMainSalesUnit,
    setMainTaxUnit,
    setMainDeliveryUnit,
    setMainCodeAnp,
    setMainGrossCost,
    setMainRealCost,
    setMainSalesMargin,
    setMainSalePrice,
    setMainTaxPrice,
    setMainConversionFactor,
    setTaxConversionFactor,
    setMainUseBalance,

    //Custos e Preços
    setMainFreightValue,
    setMainFreightPercentage,
    setMainInsuranceValue,
    setMainInsurancePercentage,
    setMainDiscountValue,
    setMainDiscountPercentage,
    setMainOthersValue,
    setMainOthersPercentage,
    setMainIcmsStValue,
    setMainIcmsStPercentage,
    setMainIpiValue,
    setMainIpiPercentage,
    setMainPisValue,
    setMainPisPercentage,
    setMainCofinsValue,
    setMainCofinsPercentage,
    setFixedPrice,

    //Códigos de Barras Adicionais
    setBarCodeAdditional,

    //Locais de estoque
    setStockLocations,

    //Tablea Preco
    setPriceTable,

    //Fornecedore
    setSupplier,
    setSupplierRef,
    setSupplierPurchaseUnit,
    setSupplierDescription,
    setSupplierOthers,
    setSupplierConversionFactor,

    //Ficha Técnica/Comercial
    setDatasheetWeight,
    setDatasheetCubage,
    setDatasheetQtdPackaging,
    setDatasheetWidth,
    setDatasheetHeight,
    setDatasheetLength,
    setDatasheetAnvisa,
    setDatasheetGeneric,
    setDatasheetObservation,
    setDatasheetBlockNf,
    setDatasheetBlockCf,
    setDatasheetPublishedPrice,
    setDatasheetTrackPrice,
    setDatasheetLastSale,
    setDatasheetLastPurchase,
    setDatasheetLastBudget,
    setDataSheetTags,
    setDataEditor,
    setDatasheetDescriptionANP,
    setDatasheetGlpPetroleum,
    setDatasheetNationalGas,
    setDatasheetImportedGas,
    setDatasheetStartingValueWithoutICMS,

    //Relacionados, Similares e Transformação
    setRelatedProducts,
    setSimilarProducts,
    setTransformationProducts,

    //Integração
    setWoocomerceShowSite,
    setWoocomerceUpdateSite,
    setLunetNegativeStock,
    setErrors,

    setBarCodeAdditionalModal,
    setMainWholesaleValue,
    setProductBackup,
    setDatasheetDepth,
  ]);

  const deleteProduct = async (id) => {
    try {
      setLoading(true);
      const callback = await deleteProduto(id, queryParams.empresa_cnpj);

      if (callback && callback.success) {
        notify("Produto excluído com sucesso!", true, "success");
      } else {
        notify("Ocorreu um erro ao excluir o produto.");
      }

      return callback;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const clearCutomerContext = () => {
    setExpanded({ main: true });
    setErrors({});
  };

  const handleCheckEditTablePrice = (check, setters, values) => {
    setters.setEditTable(check);

    if (!values) return;

    const { data } = values;

    if (check) {
      setters.setMarginModal(
        data?.margem
          ? MaskService.toMask("decimal", parseFloat(data?.margem).toFixed(2))
          : "-"
      );
      setters.setDiscountDefaultModal(
        data?.descontopadrao
          ? MaskService.toMask(
              "decimal",
              parseFloat(data?.descontopadrao).toFixed(2)
            )
          : "0,00"
      );
      setters.setDiscountMaxModal(
        data?.descontomaximopadrao
          ? MaskService.toMask(
              "decimal",
              parseFloat(data?.descontomaximopadrao).toFixed(2)
            )
          : "0,00"
      );
      setters.setCommissionModal(
        data?.comissaopadrao
          ? MaskService.toMask(
              "decimal",
              parseFloat(data?.comissaopadrao).toFixed(2)
            )
          : "0,00"
      );
    } else {
      const { tabelasprecosprodutos } = productBackup;
      let backup = tabelasprecosprodutos.find((e) => e.id === data?.id);

      setters.setMarginModal(backup?.margem ?? "0,00");
      setters.setDiscountDefaultModal(
        backup?.descontopadrao
          ? MaskService.toMask(
              "decimal",
              parseFloat(backup?.descontopadrao).toFixed(2)
            )
          : "0,00"
      );
      setters.setDiscountMaxModal(
        backup?.descontomaximopadrao
          ? MaskService.toMask(
              "decimal",
              parseFloat(backup?.descontomaximopadrao).toFixed(2)
            )
          : "0,00"
      );
      setters.setCommissionModal(
        backup?.comissaopadrao
          ? MaskService.toMask(
              "decimal",
              parseFloat(backup?.comissaopadrao).toFixed(2)
            )
          : "0,00"
      );
    }
  };

  const handleChoseUnit = (value) => {
    setMainSalesUnit(value);
    if (!mainStockUnit) setMainStockUnit(value);
    if (!mainDeliveryUnit) setMainDeliveryUnit(value);
    if (!supplierPurchaseUnit) setSupplierPurchaseUnit(value);
    if (!mainTaxUnit) setMainTaxUnit(value);
  };

  const handleDescribtion = (value) => {
    if (!mainResume) setMainResume(value.substring(0, 30));
  };

  const handleScaleFile = async ({
    where,
    stockLocationFilter,
    priceTable,
  }) => {
    setLoading(true);
    try {
      const text = await getScaleFile({
        empresa_cnpj: queryParams.empresa_cnpj,
        stockLocation: stockLocationFilter,
        priceTable: priceTable,
        where: where,
      });

      if (!text?.data?.file_base64)
        return notify(
          "Nenhum produto habilitado para ser usado em arquivo de balança."
        );

      let file = text.data.file_base64;

      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:application/octet-stream;base64," +
          encodeURIComponent(
            file.substring(file.split("").findIndex((e) => e === ",") + 1)
          )
      );

      element.setAttribute("download", "ArquivoBalanca.txt");

      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleActiveProduct = async () => {
    setLoading(true);
    try {
      if (mainActive && mainProductId && stockLocations) {
        const checkStock = await findProdutos({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: mainProductId,
          include: "estoques",
        });

        if (checkStock.success) {
          const rowStocks = checkStock.data.estoques.filter(
            (current) => removeMaskDecimal(current.qtdeatual) !== 0
          );

          if (rowStocks.length) {
            setMainActive(true);
            return notify("Produto com saldo, não pode ser inativado.");
          } else {
            setMainActive(false);
            setStockLocations((current) => {
              const copyStockLocation = [...current];
              copyStockLocation.forEach((current) => (current.inativo = "S"));
              return copyStockLocation;
            });
          }
        }
      } else if (stockLocations && mainActive) {
        setMainActive(false);
        setStockLocations((current) => {
          const copyStockLocation = [...current];
          copyStockLocation.forEach((current) => (current.inativo = "S"));
          return copyStockLocation;
        });
      } else setMainActive((current) => !current);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleCodeAnp = async (codigo) => {
    if (!codigo) return;
    let codeAnp;
    setLoading(true);

    try {
      codeAnp = await findAnpByCode(codigo);
      setDatasheetDescriptionANP(codeAnp.data.produto);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSubmit,
    handleCancelSubmit,
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
    handleDeleteProduct,
    handleCloneProduct,
    getRealCost,
    getProductPrice,
    clearCutomerContext,
    handleCreateBarCode,
    handleCheckEditTablePrice,
    removeMaskDecimal,
    clearAll,
    handleEditProduct,
    changeUStoBR,
    handleChoseUnit,
    handleDescribtion,
    handleBackSubmit,
    handleScaleFile,
    deleteProduct,
    handleActiveProduct,
    handleCodeAnp,
  };
}
